import config from 'config/common';
import { getTokenFromLocalStorage } from 'helpers/token';
import socketIOClient, { Socket } from 'socket.io-client';
import store from 'store/index';
import { user_refreshUserData } from 'store/user/actions';
import { prop__myPlans_getPlans } from 'features/prop/store/plans/actions';
import { ENotificationsTypes } from 'features/Notifications/store/actionsTypes';
import { challengeUpdated } from 'store/payment/actions';
import { PropChallenge, PropPlan } from 'services/generatedClientFromSwagger';
import { sendProductFruitsEvent } from 'helpers/productfruits';

const SOCKET_SERVER_URL = config.api.URL;
class WebSocketConnection {
    public socket: Socket;
    public initialized: boolean = false;

    public connect() {
        this.initConnection();
    }

    private initConnection() {
        this.socket = socketIOClient(SOCKET_SERVER_URL, {
            path: '/api/events',
            transports: ['websocket'],
        });

        this.initialized = true;

        this.socket.on('connect', () => {
            const token = getTokenFromLocalStorage();
            if (token) {
                this.identifyUser(token);
            }
        });

        this.socket.io.on('reconnect_attempt', () => {});
        this.socket.io.on('error', () => {});
        this.socket.io.on('reconnect_error', () => {});
        this.socket.io.on('reconnect_failed', () => {});
        this.socket.io.on('reconnect', () => {});
        this.socket.io.on('close', () => {});
        this.socket.on('disconnect', () => {
            this.initialized = false;
        });

        this.socket.on('CHALLENGE_UPDATE', async (challenge) => {
            const state = store.getState();
            await store.dispatch(user_refreshUserData() as any);
            const plans: PropPlan[] = await store.dispatch(prop__myPlans_getPlans(false, true) as any);
            const selectedChallengeId = state.prop_myPlans?.selectedChallenge?.tceChallengeID;
            if (
                selectedChallengeId === challenge.id?.toString() ||
                selectedChallengeId === challenge.orionChallengeId?.toString()
            ) {
                let crmChallenge: PropChallenge | undefined;
                const plan = plans.find((p) => p.propChallenges?.find((c) => c.tceChallengeID === selectedChallengeId));
                if (plan) {
                    crmChallenge = plan?.propChallenges?.filter((c) => c.tceChallengeID === selectedChallengeId)?.[0];
                }
                const iframe = document.getElementById('platformIframe') as HTMLIFrameElement;
                if (iframe && iframe.contentWindow) {
                    const value = { addOns: plan?.addOns, crmChallenge, plan: plan?.pPlan };
                    iframe.contentWindow.postMessage({ type: 'CHALLENGE_UPDATE', value }, '*');
                }
            }
            sendChallengeUpdateEvent(plans, challenge);

            store.dispatch(challengeUpdated() as any);
        });

        this.socket.on('newMessage', (newMessage) => {
            store.dispatch({ type: ENotificationsTypes.NEW_MESSAGE, payload: newMessage });
        });

        this.socket.on('dataUpdated', (data) => {
            switch (data.entity) {
                case 'plan':
                    store.dispatch(prop__myPlans_getPlans(false, true) as any);
                    store.dispatch(challengeUpdated() as any);
                    return;
                case 'user':
                    store.dispatch(user_refreshUserData() as any);
                    return;
            }
        });
    }

    public identifyUser = (token: string) => {
        this.socket.emit('identifyUser', token);
    };
}

export default new WebSocketConnection();
async function sendChallengeUpdateEvent(plans: PropPlan[], challenge: any) {
    const plansForEvents = plans?.find((p) =>
        p?.propChallenges?.find((c) => c.tceChallengeID === `${challenge?.orionChallengeId}`)
    );
    if (plansForEvents) {
        const eventChallenge = plansForEvents?.propChallenges?.find(
            (c) => c.tceChallengeID === `${challenge?.orionChallengeId}`
        );
        if (eventChallenge) {
            sendProductFruitsEvent(eventChallenge);
        }
    }
}
